import React from 'react';
import './MarketOverview.css';

const MarketOverview: React.FC = () => {
  // TradingView widget embed codes for most popular instruments
  
  // Market Overview Widget
  const marketOverviewUrl = "https://s.tradingview.com/embed-widget/market-overview/?locale=en#%7B%22colorTheme%22%3A%22light%22%2C%22dateRange%22%3A%2212M%22%2C%22showChart%22%3Atrue%2C%22locale%22%3A%22en%22%2C%22largeChartUrl%22%3A%22%22%2C%22isTransparent%22%3Afalse%2C%22showSymbolLogo%22%3Atrue%2C%22showFloatingTooltip%22%3Afalse%2C%22width%22%3A%22100%25%22%2C%22height%22%3A%22100%25%22%2C%22markets%22%3A%5B%22forex%22%2C%22crypto%22%2C%22index%22%5D%7D";
  
  // Major Currencies
  const eurUsdChartUrl = "https://s.tradingview.com/embed-widget/advanced-chart/?locale=en#%7B%22symbol%22%3A%22FX_IDC%3AEURUSD%22%2C%22interval%22%3A%22240%22%2C%22timezone%22%3A%22Etc%2FUTC%22%2C%22theme%22%3A%22light%22%2C%22style%22%3A%221%22%2C%22toolbar_bg%22%3A%22%23f1f3f6%22%2C%22enable_publishing%22%3Afalse%2C%22hide_top_toolbar%22%3Afalse%2C%22hide_legend%22%3Afalse%2C%22save_image%22%3Afalse%2C%22container_id%22%3A%22tradingview_eurusd%22%2C%22studies%22%3A%5B%5D%7D";
  
  const gbpUsdChartUrl = "https://s.tradingview.com/embed-widget/advanced-chart/?locale=en#%7B%22symbol%22%3A%22FX_IDC%3AGBPUSD%22%2C%22interval%22%3A%22240%22%2C%22timezone%22%3A%22Etc%2FUTC%22%2C%22theme%22%3A%22light%22%2C%22style%22%3A%221%22%2C%22toolbar_bg%22%3A%22%23f1f3f6%22%2C%22enable_publishing%22%3Afalse%2C%22hide_top_toolbar%22%3Afalse%2C%22hide_legend%22%3Afalse%2C%22save_image%22%3Afalse%2C%22container_id%22%3A%22tradingview_gbpusd%22%2C%22studies%22%3A%5B%5D%7D";
  
  const usdJpyChartUrl = "https://s.tradingview.com/embed-widget/advanced-chart/?locale=en#%7B%22symbol%22%3A%22FX_IDC%3AUSDJPY%22%2C%22interval%22%3A%22240%22%2C%22timezone%22%3A%22Etc%2FUTC%22%2C%22theme%22%3A%22light%22%2C%22style%22%3A%221%22%2C%22toolbar_bg%22%3A%22%23f1f3f6%22%2C%22enable_publishing%22%3Afalse%2C%22hide_top_toolbar%22%3Afalse%2C%22hide_legend%22%3Afalse%2C%22save_image%22%3Afalse%2C%22container_id%22%3A%22tradingview_usdjpy%22%2C%22studies%22%3A%5B%5D%7D";
  
  const usdChfChartUrl = "https://s.tradingview.com/embed-widget/advanced-chart/?locale=en#%7B%22symbol%22%3A%22FX_IDC%3AUSDCHF%22%2C%22interval%22%3A%22240%22%2C%22timezone%22%3A%22Etc%2FUTC%22%2C%22theme%22%3A%22light%22%2C%22style%22%3A%221%22%2C%22toolbar_bg%22%3A%22%23f1f3f6%22%2C%22enable_publishing%22%3Afalse%2C%22hide_top_toolbar%22%3Afalse%2C%22hide_legend%22%3Afalse%2C%22save_image%22%3Afalse%2C%22container_id%22%3A%22tradingview_usdchf%22%2C%22studies%22%3A%5B%5D%7D";
  
  const usdCadChartUrl = "https://s.tradingview.com/embed-widget/advanced-chart/?locale=en#%7B%22symbol%22%3A%22FX_IDC%3AUSDCAD%22%2C%22interval%22%3A%22240%22%2C%22timezone%22%3A%22Etc%2FUTC%22%2C%22theme%22%3A%22light%22%2C%22style%22%3A%221%22%2C%22toolbar_bg%22%3A%22%23f1f3f6%22%2C%22enable_publishing%22%3Afalse%2C%22hide_top_toolbar%22%3Afalse%2C%22hide_legend%22%3Afalse%2C%22save_image%22%3Afalse%2C%22container_id%22%3A%22tradingview_usdcad%22%2C%22studies%22%3A%5B%5D%7D";
  
  const audUsdChartUrl = "https://s.tradingview.com/embed-widget/advanced-chart/?locale=en#%7B%22symbol%22%3A%22FX_IDC%3AAUDUSD%22%2C%22interval%22%3A%22240%22%2C%22timezone%22%3A%22Etc%2FUTC%22%2C%22theme%22%3A%22light%22%2C%22style%22%3A%221%22%2C%22toolbar_bg%22%3A%22%23f1f3f6%22%2C%22enable_publishing%22%3Afalse%2C%22hide_top_toolbar%22%3Afalse%2C%22hide_legend%22%3Afalse%2C%22save_image%22%3Afalse%2C%22container_id%22%3A%22tradingview_audusd%22%2C%22studies%22%3A%5B%5D%7D";
  
  // Major Indices
  const spxChartUrl = "https://s.tradingview.com/embed-widget/advanced-chart/?locale=en#%7B%22symbol%22%3A%22SP%3ASPX%22%2C%22interval%22%3A%22240%22%2C%22timezone%22%3A%22Etc%2FUTC%22%2C%22theme%22%3A%22light%22%2C%22style%22%3A%221%22%2C%22toolbar_bg%22%3A%22%23f1f3f6%22%2C%22enable_publishing%22%3Afalse%2C%22hide_top_toolbar%22%3Afalse%2C%22hide_legend%22%3Afalse%2C%22save_image%22%3Afalse%2C%22container_id%22%3A%22tradingview_spx%22%2C%22studies%22%3A%5B%5D%7D";
  
  const nasdaqChartUrl = "https://s.tradingview.com/embed-widget/advanced-chart/?locale=en#%7B%22symbol%22%3A%22NASDAQ%3ANDX%22%2C%22interval%22%3A%22240%22%2C%22timezone%22%3A%22Etc%2FUTC%22%2C%22theme%22%3A%22light%22%2C%22style%22%3A%221%22%2C%22toolbar_bg%22%3A%22%23f1f3f6%22%2C%22enable_publishing%22%3Afalse%2C%22hide_top_toolbar%22%3Afalse%2C%22hide_legend%22%3Afalse%2C%22save_image%22%3Afalse%2C%22container_id%22%3A%22tradingview_ndx%22%2C%22studies%22%3A%5B%5D%7D";
  
  const djiChartUrl = "https://s.tradingview.com/embed-widget/advanced-chart/?locale=en#%7B%22symbol%22%3A%22INDEX%3ADJI%22%2C%22interval%22%3A%22240%22%2C%22timezone%22%3A%22Etc%2FUTC%22%2C%22theme%22%3A%22light%22%2C%22style%22%3A%221%22%2C%22toolbar_bg%22%3A%22%23f1f3f6%22%2C%22enable_publishing%22%3Afalse%2C%22hide_top_toolbar%22%3Afalse%2C%22hide_legend%22%3Afalse%2C%22save_image%22%3Afalse%2C%22container_id%22%3A%22tradingview_dji%22%2C%22studies%22%3A%5B%5D%7D";
  
  const ftseChartUrl = "https://s.tradingview.com/embed-widget/advanced-chart/?locale=en#%7B%22symbol%22%3A%22INDEX%3AFTSE%22%2C%22interval%22%3A%22240%22%2C%22timezone%22%3A%22Etc%2FUTC%22%2C%22theme%22%3A%22light%22%2C%22style%22%3A%221%22%2C%22toolbar_bg%22%3A%22%23f1f3f6%22%2C%22enable_publishing%22%3Afalse%2C%22hide_top_toolbar%22%3Afalse%2C%22hide_legend%22%3Afalse%2C%22save_image%22%3Afalse%2C%22container_id%22%3A%22tradingview_ftse%22%2C%22studies%22%3A%5B%5D%7D";
  
  const daxChartUrl = "https://s.tradingview.com/embed-widget/advanced-chart/?locale=en#%7B%22symbol%22%3A%22INDEX%3ADAX%22%2C%22interval%22%3A%22240%22%2C%22timezone%22%3A%22Etc%2FUTC%22%2C%22theme%22%3A%22light%22%2C%22style%22%3A%221%22%2C%22toolbar_bg%22%3A%22%23f1f3f6%22%2C%22enable_publishing%22%3Afalse%2C%22hide_top_toolbar%22%3Afalse%2C%22hide_legend%22%3Afalse%2C%22save_image%22%3Afalse%2C%22container_id%22%3A%22tradingview_dax%22%2C%22studies%22%3A%5B%5D%7D";
  
  // Cryptocurrencies
  const btcChartUrl = "https://s.tradingview.com/embed-widget/advanced-chart/?locale=en#%7B%22symbol%22%3A%22BITSTAMP%3ABTCUSD%22%2C%22interval%22%3A%22240%22%2C%22timezone%22%3A%22Etc%2FUTC%22%2C%22theme%22%3A%22light%22%2C%22style%22%3A%221%22%2C%22toolbar_bg%22%3A%22%23f1f3f6%22%2C%22enable_publishing%22%3Afalse%2C%22hide_top_toolbar%22%3Afalse%2C%22hide_legend%22%3Afalse%2C%22save_image%22%3Afalse%2C%22container_id%22%3A%22tradingview_btc%22%2C%22studies%22%3A%5B%5D%7D";
  
  const ethChartUrl = "https://s.tradingview.com/embed-widget/advanced-chart/?locale=en#%7B%22symbol%22%3A%22BITSTAMP%3AETHUSD%22%2C%22interval%22%3A%22240%22%2C%22timezone%22%3A%22Etc%2FUTC%22%2C%22theme%22%3A%22light%22%2C%22style%22%3A%221%22%2C%22toolbar_bg%22%3A%22%23f1f3f6%22%2C%22enable_publishing%22%3Afalse%2C%22hide_top_toolbar%22%3Afalse%2C%22hide_legend%22%3Afalse%2C%22save_image%22%3Afalse%2C%22container_id%22%3A%22tradingview_eth%22%2C%22studies%22%3A%5B%5D%7D";
  
  const xrpChartUrl = "https://s.tradingview.com/embed-widget/advanced-chart/?locale=en#%7B%22symbol%22%3A%22BITSTAMP%3AXRPUSD%22%2C%22interval%22%3A%22240%22%2C%22timezone%22%3A%22Etc%2FUTC%22%2C%22theme%22%3A%22light%22%2C%22style%22%3A%221%22%2C%22toolbar_bg%22%3A%22%23f1f3f6%22%2C%22enable_publishing%22%3Afalse%2C%22hide_top_toolbar%22%3Afalse%2C%22hide_legend%22%3Afalse%2C%22save_image%22%3Afalse%2C%22container_id%22%3A%22tradingview_xrp%22%2C%22studies%22%3A%5B%5D%7D";
  
  const goldChartUrl = "https://s.tradingview.com/embed-widget/advanced-chart/?locale=en#%7B%22symbol%22%3A%22OANDA%3AXAUUSD%22%2C%22interval%22%3A%22240%22%2C%22timezone%22%3A%22Etc%2FUTC%22%2C%22theme%22%3A%22light%22%2C%22style%22%3A%221%22%2C%22toolbar_bg%22%3A%22%23f1f3f6%22%2C%22enable_publishing%22%3Afalse%2C%22hide_top_toolbar%22%3Afalse%2C%22hide_legend%22%3Afalse%2C%22save_image%22%3Afalse%2C%22container_id%22%3A%22tradingview_xauusd%22%2C%22studies%22%3A%5B%5D%7D";
  
  const oilChartUrl = "https://s.tradingview.com/embed-widget/advanced-chart/?locale=en#%7B%22symbol%22%3A%22OANDA%3AUSOIL%22%2C%22interval%22%3A%22240%22%2C%22timezone%22%3A%22Etc%2FUTC%22%2C%22theme%22%3A%22light%22%2C%22style%22%3A%221%22%2C%22toolbar_bg%22%3A%22%23f1f3f6%22%2C%22enable_publishing%22%3Afalse%2C%22hide_top_toolbar%22%3Afalse%2C%22hide_legend%22%3Afalse%2C%22save_image%22%3Afalse%2C%22container_id%22%3A%22tradingview_usoil%22%2C%22studies%22%3A%5B%5D%7D";

  return (
    <div className="market-overview-container">
      <div className="market-header">
        <h2>Market Overview</h2>
        <p>Real-time market data for the most popular instruments</p>
      </div>
      
      {/* Main market overview widget */}
      <div className="market-overview-widget">
        <iframe 
          src={marketOverviewUrl}
          width="100%"
          height="500"
          frameBorder={0}
          title="TradingView Market Overview"
        ></iframe>
      </div>
      
      {/* Popular instruments section */}
      <div className="popular-instruments">
        <h3>Most Popular Instruments</h3>
        
        <div className="instruments-grid">
          {/* Major Currencies */}
          <div className="instrument-section">
            <h4>Major Forex</h4>
            <div className="chart-grid">
              <div className="chart-container">
                <iframe 
                  src={eurUsdChartUrl}
                  width="100%"
                  height="300"
                  frameBorder={0}
                  title="EUR/USD Chart"
                ></iframe>
              </div>
              <div className="chart-container">
                <iframe 
                  src={gbpUsdChartUrl}
                  width="100%"
                  height="300"
                  frameBorder={0}
                  title="GBP/USD Chart"
                ></iframe>
              </div>
              <div className="chart-container">
                <iframe 
                  src={usdJpyChartUrl}
                  width="100%"
                  height="300"
                  frameBorder={0}
                  title="USD/JPY Chart"
                ></iframe>
              </div>
              <div className="chart-container">
                <iframe 
                  src={usdChfChartUrl}
                  width="100%"
                  height="300"
                  frameBorder={0}
                  title="USD/CHF Chart"
                ></iframe>
              </div>
              <div className="chart-container">
                <iframe 
                  src={usdCadChartUrl}
                  width="100%"
                  height="300"
                  frameBorder={0}
                  title="USD/CAD Chart"
                ></iframe>
              </div>
              <div className="chart-container">
                <iframe 
                  src={audUsdChartUrl}
                  width="100%"
                  height="300"
                  frameBorder={0}
                  title="AUD/USD Chart"
                ></iframe>
              </div>
            </div>
          </div>
          
          {/* Major Indices */}
          <div className="instrument-section">
            <h4>Indices</h4>
            <div className="chart-grid">
              <div className="chart-container">
                <iframe 
                  src={spxChartUrl}
                  width="100%"
                  height="300"
                  frameBorder={0}
                  title="S&P 500 Chart"
                ></iframe>
              </div>
              <div className="chart-container">
                <iframe 
                  src={nasdaqChartUrl}
                  width="100%"
                  height="300"
                  frameBorder={0}
                  title="NASDAQ Chart"
                ></iframe>
              </div>
              <div className="chart-container">
                <iframe 
                  src={djiChartUrl}
                  width="100%"
                  height="300"
                  frameBorder={0}
                  title="Dow Jones Chart"
                ></iframe>
              </div>
              <div className="chart-container">
                <iframe 
                  src={ftseChartUrl}
                  width="100%"
                  height="300"
                  frameBorder={0}
                  title="FTSE 100 Chart"
                ></iframe>
              </div>
              <div className="chart-container">
                <iframe 
                  src={daxChartUrl}
                  width="100%"
                  height="300"
                  frameBorder={0}
                  title="DAX Chart"
                ></iframe>
              </div>
            </div>
          </div>
          
          {/* Cryptocurrencies & Commodities */}
          <div className="instrument-section">
            <h4>Digital Assets & Commodities</h4>
            <div className="chart-grid">
              <div className="chart-container">
                <iframe 
                  src={btcChartUrl}
                  width="100%"
                  height="300"
                  frameBorder={0}
                  title="Bitcoin Chart"
                ></iframe>
              </div>
              <div className="chart-container">
                <iframe 
                  src={ethChartUrl}
                  width="100%"
                  height="300"
                  frameBorder={0}
                  title="Ethereum Chart"
                ></iframe>
              </div>
              <div className="chart-container">
                <iframe 
                  src={xrpChartUrl}
                  width="100%"
                  height="300"
                  frameBorder={0}
                  title="Ripple Chart"
                ></iframe>
              </div>
              <div className="chart-container">
                <iframe 
                  src={goldChartUrl}
                  width="100%"
                  height="300"
                  frameBorder={0}
                  title="Gold Chart"
                ></iframe>
              </div>
              <div className="chart-container">
                <iframe 
                  src={oilChartUrl}
                  width="100%"
                  height="300"
                  frameBorder={0}
                  title="Oil Chart"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketOverview;